import { CalmTheme } from '@calm-web/design-system';

export const sleepTheme = {
	name: 'subpage-sleep',
	palette: {
		...CalmTheme.palette,
		buttonPrimaryBg: 'linear-gradient(180deg, #371E63 0%, #103071 100%)',
		bannerText: '#1C2056',
	},
};

export const stressTheme = {
	name: 'subpage-stress',
	palette: {
		...CalmTheme.palette,
		buttonPrimaryBg: 'linear-gradient(180deg, #2477AA 0%, #6461E0 100%)',
		bannerText: '#1A3E6F',
	},
};

export const mindfulnessTheme = {
	name: 'subpage-mindfulness',
	palette: {
		...CalmTheme.palette,
		buttonPrimaryBg: 'linear-gradient(135deg, #2E6F3B 0%, #3879AF 100%)',
		bannerText: '#1F4D30',
	},
};
